(function(Manogi, $, undefined) {
    
    //Private

    //Public
    

   
    Manogi.startSearch = function($search) {
        var needle = $.trim($search.find('input[name=search_needle]').val());
        if(needle.length > 2){
            $.oc.stripeLoadIndicator.show();
            window.location.href = '/'+$('html').attr('lang')+'/suche/'+needle;
        }
        
    };
    


}( window.Manogi = window.Manogi || {}, jQuery ));